var _defs, _polyline, _line, _line2, _polyline2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew240({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "4.37 3.61 12.26 10.71 15.62 10.71"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 3.74,
    y1: 9.03,
    x2: 3.74,
    y2: 12.39
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 0.38,
    y1: 10.71,
    x2: 3.74,
    y2: 10.71
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "4.37 3.61 12.26 10.71 15.62 10.71"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 3.74,
    y1: 9.03,
    x2: 3.74,
    y2: 12.39
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 0.38,
    y1: 10.71,
    x2: 3.74,
    y2: 10.71
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew240);
export default __webpack_public_path__ + "static/media/Symbolpack_New_240.bce6bc3d866bb2da59aae0d265e714fb.svg";
export { ForwardRef as ReactComponent };